import type { FC } from 'react';
import Select, { type SelectOption } from './select';
import styles from '../styles/form-field.module.scss';

type BaseFormFieldProps = {
    label: string;
    helperText?: string;
    constraintText?: string;
    required?: boolean;
};

type TextFormFieldProps = BaseFormFieldProps & {
    inputType: 'text' | 'tel' | 'date' | 'email' | 'textarea';
    placeholder?: string;
    value: string;
    readOnly?: boolean;
    onChange?: (value: string) => void;
};

type SelectFormFieldProps = BaseFormFieldProps & {
    inputType: 'select';
    name: string;
    selectTitle: string;
    options: SelectOption[];
    value: string;
    onChange?: (value: string) => void;
};

type FormFieldProps = TextFormFieldProps | SelectFormFieldProps;

const FormField: FC<FormFieldProps> = (props) => {
    const { inputType, label, helperText, constraintText, required } = props;

    return (
        <div className={styles.formField}>
            <div className={styles.fieldLabel}>
                <span>{label}</span>
                {required && <span className={styles.required}>必須</span>}
            </div>
            {helperText && <div className={styles.fieldHelperText}>{helperText}</div>}
            {inputType === 'select' ? (
                <Select
                    name={props.name}
                    title={props.selectTitle}
                    options={props.options}
                    selectedOption={props.value.length > 0 ? props.value : null}
                    onSelect={(value) => props.onChange?.(value)}
                />
            ) : inputType === 'textarea' ? (
                <textarea
                    required={required}
                    readOnly={props.readOnly}
                    className={`${styles.fieldTextarea} ${props.readOnly ? styles.blueBorder : ''}`}
                    placeholder={props.readOnly ? '' : props.placeholder}
                    value={props.value}
                    onChange={(e) => props.onChange?.(e.target.value)}
                />
            ) : (
                <input
                    type={inputType}
                    required={required}
                    readOnly={props.readOnly}
                    className={`${styles.fieldInput} ${props.readOnly ? styles.blueBorder : ''}`}
                    placeholder={props.readOnly ? '' : props.placeholder}
                    value={props.value}
                    onChange={(e) => props.onChange?.(e.target.value)}
                />
            )}
            {constraintText && <div className={styles.fieldConstraintText}>{constraintText}</div>}
        </div>
    );
};

export default FormField;
